import { computed, inject, Injectable, signal } from '@angular/core';
import { LicenseManager } from 'ag-grid-enterprise';
import { UserpilotService } from 'src/app/shared/userpilot/userpilot.service';

@Injectable({ providedIn: 'root' })
export class ThirdPartyLicenseService {
  readonly #userpilotService = inject(UserpilotService);
  readonly #isGridLicenseReady = signal(false);
  readonly isGridLicenseReady = computed(() => this.#isGridLicenseReady());

  setUserpilotLicense(license: string) {
    this.#userpilotService.initialize(license);
  }

  setAgGridLicense(license: string) {
    if (!this.isGridLicenseReady()) {
      LicenseManager.setLicenseKey(license);
      this.#isGridLicenseReady.set(true);
    }
  }
}
